document.addEventListener("alpine:init", () => {
  Alpine.data("cartItem", () => ({
    quantity: null,

    init() {
      let interval = null
      this.$watch('quantity', async (value, oldValue) => {
        if (oldValue === null) return

        if (value === oldValue) return
        
        clearInterval(interval)
        interval = setTimeout(() => {
          this.$refs.form.submit()
        }, 1000)
      })
    },

    // addQuantity() {
    //   this.quantity += 1
    // },

    // removeQuantity() {
    //   this.quantity -= 1
    // }
  }))
})

$(function() {
  let block_date = document.querySelector('#block_dates');
  let dates = JSON.parse(block_date.innerHTML).trim().split("\n") || [];

  let delivery_time = document.querySelector('#delivery_time');
  let times = JSON.parse(delivery_time.innerHTML).trim().split("\n") || [];

  let delivery_time_on_date = document.querySelector('#delivery_time_on_date');
  let times_on_date = delivery_time_on_date.innerHTML ? JSON.parse(delivery_time_on_date.innerHTML).trim().split("\n") || [] : [];

  let times_on_date_obj = times_on_date.map((item) => {
    let [date, time] = item.split(" ")
    return {date, time}
  });


  let last = times.pop();
  times.unshift(last)

  function getTimeSlots(currentDate, day) {
    let date = currentDate instanceof Date ? dayjs(currentDate) : dayjs(currentDate, 'DD-MM-YYYY');

    if (times[day] === "Gesloten") {
      return []
    }


    const timeOnDate = times_on_date_obj.find((item) => {
      return item.date === date.format('DD-MM-YYYY');
    });

    if (!date.isSame(dayjs(), 'day')) {
      return [1]
    }
    
    let time = timeOnDate ? timeOnDate.time : times[day];
    const [start, end] = time.split("-");

    let minDate = dayjs(date).set('hour', start.split(':')[0]).set('minute', start.split(':')[1]).set('second', 0).set('millisecond', 0);
    let maxDate = dayjs(date).set('hour', end.split(':')[0]).set('minute', end.split(':')[1]).set('second', 0).set('millisecond', 0);
    
    let timeSlots = [];
    while (minDate.isBefore(maxDate) || minDate.isSame(maxDate)) {
      timeSlots.push(minDate.format('HH:mm'));
      minDate = minDate.add(30, 'minute');
    }

    timeSlots = timeSlots.filter(slot => {
      const [hour, minute] = slot.split(':');
      let curr = dayjs(date).set('hour', hour).set('minute', minute).set('second', 0).set('millisecond', 0)
      return curr.isAfter(dayjs().add(30, 'minute'), 'minute');
    });

    return timeSlots
  }

  // block input on #block_dates_input

  $('#block_dates_input').keydown(function(e) {
    e.preventDefault();
    return false;
  });

  $('#delivery_time_input').keydown(function(e) {
    e.preventDefault();
    return false;
  });

  $('#block_dates_input').datepicker({
    minDate: 0,
    dateFormat: 'dd-mm-yy',
    firstDay: 1,
    beforeShowDay: function(date) {    
      let day = date.getDay();

      
      let isBlocked = dates.find((item) => {
        return item == dayjs(date).format('DD-MM-YYYY');
      });

      if (isBlocked) {
        return [false, ''];
      }
      
      if (getTimeSlots(date, day).length === 0) {
        return [false, ''];
      }

      return [times[day].includes("-"), ''];
    }
  });

  $('#delivery_time_input').timepicker({
    'className' : 'tijdkiezen',
    'timeFormat': 'H:i', 'step': 30, 'scrollDefault': 'now', 'minTime': '08:00am', 'maxTime': '12:00pm',
  });

  let now = new Date();

  

  $('#block_dates_input').change(function() {
    $('#delivery_time_input').prop('readonly', false);
    $('#delivery_time_input').prop('disabled', false);

    let day = dayjs($(this).val(), 'DD-MM-YYYY').day();

    const timeOnDate = times_on_date_obj.find((item) => {
      return item.date === $(this).val();
    });

    let time = timeOnDate ? timeOnDate.time : times[day]
    const [start, end] = time.split("-");


    if (dayjs($(this).val(), 'DD-MM-YYYY').isSame(dayjs(), 'day')) {
      
      // dayjs use  time
      let date = dayjs($(this).val(), 'DD-MM-YYYY');

      // let minDate = date.set('hour', start.split(':')[0]).set('minute', start.split(':')[1]).set('second', 0).set('millisecond', 0);
      // let maxDate = dayjs().set('hour', end.split(':')[0]).set('minute', end.split(':')[1]).set('second', 0).set('millisecond', 0);
      
      // let timeSlots = [];
      // while (minDate.isBefore(maxDate) || minDate.isSame(maxDate)) {
      //   timeSlots.push(minDate.format('HH:mm'));
      //   minDate = minDate.add(30, 'minute');
      // }

      const timeSlots = getTimeSlots($(this).val(), day)

      $('#delivery_time_input').timepicker('option', { 'minTime': timeSlots[0] });
  } else {
      $('#delivery_time_input').timepicker('option', { 'minTime': start });
    }

    $('#delivery_time_input').timepicker('option', { 'maxTime': end });


    if (dayjs($(this).val(), 'DD-MM-YYYY').isSame(dayjs().set('month', 4).set('date', 8), 'day')) {
      $('#delivery_time_input').timepicker('option', { 'maxTime': '13:00' });
    }
    
    
    // $('#delivery_time_input').timepicker({
    //   'className' : 'tijdkiezen',
    //   'timeFormat': 'H:i', 'step': 30, 'scrollDefault': 'now', 'minTime': '08:00am', 'maxTime': '12:00pm',
    // });
  });

  // let canSubmitCheckout = false;

  // $("#zipcodeCheck").change(async function() {
  //   console.log($(this).val());
  //   const zipcode = $(this).val();
  //   const res = await fetch("https://bakker-de-graaf-backend.ubo-dev.nl/check-zipcode?zipcode=" + zipcode)
  //   const text = await res.text()
  //   const isValid = text === "true";

  //   if (isValid) {
  //     $("#zipcodeCheckMsg").html("Postcode is binnen ons bezorggebied"); 
  //     $("#zipcodeCheckMsg").removeClass("text-error");
  //     $("#zipcodeCheckMsg").addClass("text-success");
  //     canSubmitCheckout = true;
  //   } else {
  //     $("#zipcodeCheckMsg").html("Deze postcode is niet binnen <br /> ons bezorggebied"); 
  //     $("#zipcodeCheckMsg").removeClass("text-success");
  //     $("#zipcodeCheckMsg").addClass("text-error");
  //     canSubmitCheckout = false;
  //   }
  // });

  $("#cart").submit(function () {
    if ($.trim($('#block_dates_input').val()) === '') {
      alert('Selecteer de datum van levering');
      return false;
    }
    if ($.trim($('#delivery_time_input').val()) === '') {
      alert('Selecteer de tijd van levering');
      return false;
    }

    // if (!canSubmitCheckout) {
    //   alert("Met deze postcode kan je geen bestelling plaatsen.")
    //   return false;
    // }
  })
});